import type { I18nLanguage, I18nScopedKey } from 'i18n';

import { BASE_URL } from './utils/getBaseUrl/getBaseUrl';

const baseUrl = BASE_URL[process.env.NODE_ENV as keyof typeof BASE_URL];

const aiBaleGuideFiles: Partial<Record<I18nLanguage, string>> = {
  'de-DE': 'AI-bale-de.pdf',
  'en-GB': 'AI-bale-en.pdf',
  'es-ES': 'AI-bale-es.pdf',
  'it-IT': 'AI-bale-it.pdf',
};

const getAiBaleGuideUrl = (language: I18nLanguage) => {
  return `${baseUrl}${aiBaleGuideFiles[language] ?? aiBaleGuideFiles['en-GB']}`;
};

export const guideImages = {
  badBaleBlurry: `${baseUrl}images/bad-bale-blurry.png`,
  badBaleClose: `${baseUrl}images/bad-bale-close.png`,
  badBaleFlatPacked: `${baseUrl}images/bad-bale-flat-packed.png`,
  badBaleManyFar: `${baseUrl}images/bad-bale-many-far.png`,
  badBaleManyFar2: `${baseUrl}images/bad-bale-many-far-2.png`,
  badBaleManySides: `${baseUrl}images/bad-bale-many-sides.png`,
  badBaleNotStraight: `${baseUrl}images/bad-bale-not-straight.png`,
  badBaleUnclearBale: `${baseUrl}images/bad-bale-unclear-bale.png`,
  badBriquetteOne: `${baseUrl}images/bad-briquette-one.png`,
  badBriquetteThree: `${baseUrl}images/bad-briquette-three.png`,
  badBriquetteTwo: `${baseUrl}images/bad-briquette-two.png`,
  badLooseCannotSeeMaterial: `${baseUrl}images/bad-loose-cannot-see-material.png`,
  badLooseHeapedBig: `${baseUrl}images/bad-loose-heaped-big.png`,
  badLooseLargeMarkings: `${baseUrl}images/bad-loose-large-markings.png`,
  badLooseNotGround: `${baseUrl}images/bad-loose-not-ground.png`,
  badLooseShadow: `${baseUrl}images/bad-loose-shadow.png`,
  badLooseTouchesEdge: `${baseUrl}images/bad-loose-touches-edge.png`,
  baleComplete: `${baseUrl}images/bale-complete.webp`,
  baleOneMetre: `${baseUrl}images/bale-one-metre.png`,
  briquetteDistance: `${baseUrl}images/briquette-distance.png`,
  clearPile: `${baseUrl}images/clear-pile.gif`,
  goodBaleBackgroundOk: `${baseUrl}images/good-bale-background-ok.png`,
  goodBaleBaleFocus: `${baseUrl}images/good-bale-bale-focus.png`,
  goodBaleDistance: `${baseUrl}images/good-bale-distance.png`,
  goodBaleFaceShown: `${baseUrl}images/good-bale-face-shown.png`,
  goodBaleNotTight: `${baseUrl}images/good-bale-not-tight.png`,
  goodBaleNotTight2: `${baseUrl}images/good-bale-not-tight-2.png`,
  goodBaleQualityDistance: `${baseUrl}images/good-bale-quality-distance.png`,
  goodBaleQualityPhoto: `${baseUrl}images/good-bale-quality-photo.png`,
  goodBriquetteOne: `${baseUrl}images/good-briquette-one.png`,
  goodBriquetteThree: `${baseUrl}images/good-briquette-three.png`,
  goodBriquetteTwo: `${baseUrl}images/good-briquette-two.png`,
  goodLooseFullMaterial: `${baseUrl}images/good-loose-full-material.png`,
  goodLoosePurpleLines: `${baseUrl}images/good-loose-purple-lines.png`,
  goodLooseSpreadVeryWell: `${baseUrl}images/good-loose-spread-very-well.png`,
  goodLooseSpreadWell: `${baseUrl}images/good-loose-spread-well.png`,
  goodLooseWithinBlackBox: `${baseUrl}images/good-loose-within-black-box.png`,
  makeAPile: `${baseUrl}images/make-a-pile.gif`,
  reviewDelete: `${baseUrl}images/review-delete.webp`,
};

export interface HelpGuideSubcategory {
  label: I18nScopedKey<'features'>;
  children: {
    label: I18nScopedKey<'features'>;
    description?: I18nScopedKey<'features'>;
    getUrl: (language: I18nLanguage) => string;
  }[];
}

export interface HelpGuideSection {
  label: I18nScopedKey<'features'>;
  subcategories: HelpGuideSubcategory[];
}

export const helpGuides: HelpGuideSubcategory['children'] = [
  {
    getUrl: getAiBaleGuideUrl,
    label: 'backlog.helpGuides.data.guides.aiBale',
  },
];
const qualityControlSubcategories: HelpGuideSubcategory[] = [
  {
    children: helpGuides,
    label: 'backlog.helpGuides.data.subcategories.howToTakeGreatAiPhotos',
  },
];

const qualityControlSection: HelpGuideSection = {
  label: 'backlog.helpGuides.data.sections.qualityControlGuides',
  subcategories: qualityControlSubcategories,
};

const contactSupportSection: HelpGuideSection = {
  label: 'backlog.helpGuides.data.sections.contactSupport',
  subcategories: [
    {
      children: [
        {
          getUrl: () => 'mailto:support@safi.co',
          label: 'backlog.helpGuides.data.guides.emailSupport',
        },
      ],
      label: 'backlog.helpGuides.data.subcategories.emailSupportPrompt',
    },
  ],
};

export const helpGuideSections: HelpGuideSection[] = [qualityControlSection, contactSupportSection];
